import React from "react";
import "./style.scss";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { LinksNetwork } from "../../../pages/Notification/LinksNetwork";

const footerData = {
  en: {
    copyrights: `Copyrights © 2009-${new Date()
      .getFullYear()
      .toString()} ItFox`,
    text: "Subscribe to our social networks",
    privacy: "Privacy policy",
    main: "Main",
    cases: "Cases",
  },
  ru: {
    copyrights: `Авторское право © 2009-${new Date()
      .getFullYear()
      .toString()} ItFox. Все права защищены.`,
    text: "Подписывайтесь на наши соц. сети",
    privacy: "Политика конфиденциальности",
    main: "Главная",
    cases: "Кейсы",
  },
};

export const Footer = ({ lang, page }) => {
  return (
    <footer className="footer">
      <section
        className={`base-section ${page === "main" ? "section__margin" : ""}`}
      >
        <div className="container">
          <div className="wrapper-logo">
            <div>
              <img
                className="brand-logo"
                src="/img/ITWEBFOX WHITE_TXT2FIX_NEW.svg"
                alt="brand-logo"
              />
              <div className="heading">{footerData[lang].text}</div>
            </div>
            <a
              target="_blank"
              href="https://arda.digital/ "
              aria-label="ARDA"
              rel="noopener noreferrer"
              // onMouseOver={() => setIsHover(true)}
              // onMouseLeave={() => setIsHover(false)}
            >
              <img width="60" height="60" src={`/img/arda.svg`} alt="" />
            </a>
          </div>
          <div className="wrapper-info">
            <div className="item-info">
              <LinksNetwork color="#141414" bg="#fff" />
              <Link
                // target="_blank"
                to={`/privacy-policy/${lang}`}
                className="link"
              >
                {footerData[lang].privacy}
              </Link>
              <div className="copyrights">{footerData[lang].copyrights}</div>
            </div>
            <div className="item-info">
              <LinksNetwork color="#141414" bg="#fff" />
              <Link to={`/main/${lang}`} className="link">
                {footerData[lang].main}
              </Link>
              <Link to={`/portfolio/${lang}`} className="link">
                {footerData[lang].cases}
              </Link>
              <a href="tel:+79288542462" className="link">
                +7 (928) 854-24-62
              </a>
              <a href="mailto:hello@itfox-web.com" className="link">
                hello@itfox-web.com
              </a>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};
